import _objectWithoutProperties from "/home/royce/web/speakers/jay/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Link } from "theme-ui";
var tab = ["_blank", "noopener noreferrer"];
export default function Anchor(_ref) {
  var to = _ref.to,
      t = _ref.t,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["to", "t", "children"]);

  t = tab;
  return /*#__PURE__*/React.createElement(Link, _extends({
    href: to,
    target: t ? t[0] : "",
    rel: t ? t[1] : ""
  }, rest), children);
}